var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LINKS_LIST } from '../../constants/menu';
import Link from '../../components/Link';
import SubMenu from '../../parts/NavBar/SubMenu';
import styles from '../../parts/NavBar/index.module.scss';
import { ANIM_SPEED } from '../../constants/anim';
const MENU_ID = 'nav_bar_link_wrap';
const NavBar = ({ withoutMyAccount }) => {
    const [activeMenuLink, setMenuActiveLink] = useState(null);
    const _handleMenuClick = ({ target }) => {
        const isSameLinkClick = target.dataset.navigateTo === activeMenuLink;
        setMenuActiveLink(isSameLinkClick ? null : target.dataset.navigateTo);
    };
    const _renderMenu = (_a, index) => {
        var { id, navigateTo, isSPA, subMenu } = _a, link = __rest(_a, ["id", "navigateTo", "isSPA", "subMenu"]);
        if (withoutMyAccount && index === LINKS_LIST.length - 1) {
            return null;
        }
        const isActiveLink = activeMenuLink === navigateTo;
        const isMobileSubMenu = isActiveLink;
        const _renderSubMenu = () => React.createElement(SubMenu, { subMenu: subMenu });
        const _renderSubMenuWithMobileAnimation = () => {
            return (React.createElement(CSSTransition, { in: isMobileSubMenu, classNames: 'navbar-mobile', timeout: ANIM_SPEED, unmountOnExit: true }, _renderSubMenu()));
        };
        return (React.createElement("li", { key: id, "data-type": MENU_ID, "data-id": navigateTo, "data-sub-menu": !!subMenu, className: styles.navBarLinkWrap },
            React.createElement(Link, Object.assign({}, link, { label: link.label, id: id, navigateTo: navigateTo, isSPA: isSPA, type: 'menu', withArrow: !!subMenu, isFullWidth: true, noUnderscore: true, isOpen: isMobileSubMenu, isActive: isActiveLink, arrowSize: 'M', onClick: _handleMenuClick, preventNavigation: !!subMenu, withoutFill: true })),
            _renderSubMenuWithMobileAnimation()));
    };
    return (React.createElement("nav", null,
        React.createElement("ul", { className: styles.menuWrap }, LINKS_LIST.map(_renderMenu))));
};
export default NavBar;
